import React from 'react';

function QuoteSection() {
  const scrollToNextSection = () => {
    const benefitsSection = document.querySelector('#benefits-section');
    if (benefitsSection) {
      benefitsSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="relative z-10 bg-gradient-to-br from-white to-gray-50 py-16 sm:py-24">
      <div className="max-w-7xl mx-auto px-4">
        <blockquote>
          <p className="text-xl sm:text-2xl font-light text-center text-gray-900 max-w-5xl mx-auto leading-relaxed">
            Comprehensive <span className="font-medium text-primary-600">estate planning</span> with <span className="font-medium text-primary-600">attorney review</span> and <span className="font-medium text-primary-600">insurance coordination</span> — all in one place.
          </p>
        </blockquote>
      </div>
      
      <button 
        onClick={scrollToNextSection}
        className="absolute -bottom-3 left-1/2 transform -translate-x-1/2 text-gray-400 hover:text-primary-600 transition-all duration-300 cursor-pointer group z-10"
        aria-label="Scroll to next section"
      >
        <div className="bg-white rounded-full p-2 shadow-md group-hover:shadow-lg transition-shadow duration-300">
          <svg 
            className="w-7 h-7 motion-safe:animate-float" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M19 13l-7 7m0 0l-7-7m7 7V4" 
            />
          </svg>
        </div>
      </button>
    </div>
  );
}

export default QuoteSection; 